<template>
    <layout-card
        :isCustomizable="settings.isCustomizable"
        :loading="loading"
        :type="type"
        :showHeader="!error"
        class="card-report"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', settings.type)"
        @refresh-card="toggleReport"
    >
        <!-- SLOTTED TITLE -->
        <template slot="title">
            {{ name }}
        </template>
        <!-- SLOTED ACTIONS -->
        <template slot="actions"> </template>

        <!-- SLOTED CONTENT -->
        <template slot="content">
            <error-card
                v-if="error"
                :placeHolderText="
                    $t.__('dashboard.cards.ReportCard.service_not_available_try_again_later')
                "
            />
            <error-card v-if="!error && tooLongToFetchData">
                <template slot="placeholder">
                    <p
                        class="error-card--timeout dinlineb acenter fs-3 typographies-paragraph-medium-semibold"
                        v-html="placeholderFetchFail"
                    ></p>
                </template>
            </error-card>

            <!-- eslint-disable -->
            <template v-if="!error && !tooLongToFetchData && showCumulCard && data">
                <luzmo-embed-dashboard
                    v-if="isLuzmoReportsEnabled"
                    ref="dashboardInstance"
                    :dashboardId="data.dashboard"
                    :authKey="data.key"
                    :authToken="data.token"
                    :language="customSettings.language"
                    @itemsRendered="handleRendered"
                    class="cumul-embed"
                />

                <cumulio-dashboard
                    v-else
                    ref="dashboardInstance"
                    :dashboardId="data.dashboard"
                    :authKey="data.key"
                    :authToken="data.token"
                    :language="customSettings.language"
                    @itemsRendered="handleRendered"
                    class="cumul-embed"
                />
            </template>
            <!-- eslint-enable -->
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import CardMixin from './CardMixin.js';
import ErrorCard from './ErrorCard.vue';
import Feature from 'Services/Feature';

export default {
    components: {
        ErrorCard,
        LayoutCard,
    },
    mixins: [CardMixin],
    data() {
        return {
            timeoutEvent: null,
            timeoutLimit: this.timeout * 1000,
            tooLongToFetchData: false,
            iframeFullyRendered: false,
            showCumulCard: true,
            renderingStartsAt: null,
        };
    },
    events: {
        'reportCard:refresh': async function (event, data) {
            if (data !== this.cardData.dashboard) return;

            this.toggleReport();
        },
    },
    computed: {
        isLuzmoReportsEnabled() {
            return Feature.isEnabled('reports-luzmo');
        },
        placeholderFetchFail() {
            return this.$l10n.__(
                'Vous pouvez %(startTag)s actualiser %(endTag)s la carte ou réessayer plus tard.',
                {
                    startTag: `<a href="javascript:;" class="colors-common-text-primary-default" onclick="window.sellsyapp.$events.trigger('reportCard:refresh', '${this.cardData.dashboard}')">`,
                    endTag: '</a>',
                },
            );
        },
    },
    mounted() {
        this.renderingStartsAt = new Date().valueOf();
        this.setLoadingTimeout();
    },
    beforeDestroy() {
        clearTimeout(this.timeoutEvent);
    },
    methods: {
        handleRendered() {
            this.iframeFullyRendered = true;
            const endAt = new Date().valueOf();

            this.$emit('set-monitored-report-cards', {
                type: this.type,
                dashboard: this.settings.type,
                start: this.renderingStartsAt,
                end: endAt,
                display: !this.tooLongToFetchData,
            });
        },
        setLoadingTimeout() {
            this.timeoutEvent = setTimeout(() => {
                if (!this.iframeFullyRendered) {
                    this.tooLongToFetchData = true;
                    this.loading = false;
                    this.showCumulCard = false;
                    const endAt = new Date().valueOf();
                    this.$emit('set-monitored-report-cards', {
                        type: this.type,
                        dashboard: this.settings.type,
                        start: this.renderingStartsAt,
                        end: endAt,
                        display: !this.tooLongToFetchData,
                    });
                }
            }, this.timeoutLimit);
        },
        reloadOnErrorOrTimeout() {
            this.tooLongToFetchData = false;
            this.showCumulCard = true;
            this.setLoadingTimeout();
        },
        toggleReport() {
            if (!this.iframeFullyRendered) {
                this.reloadOnErrorOrTimeout();
                return;
            }
            this.$refs.dashboardInstance.reloadDashboard();
        },
    },
};
</script>

<style lang="scss">
.card.card-report .card-body {
    overflow-x: auto;
    overflow-y: hidden;

    .error-card--timeout {
        color: var(--colors-common-text-standard-caption);

        a {
            &:hover {
                color: var(--colors-common-text-primary-hover);
            }
        }
    }
}
</style>
